<template>
  <div class="main common-table-cnt search">
    <el-form :inline="true" :model="formInline" class=" demo-form-inline">
      <el-form-item :label="$t('mechanism')">
        <el-select ref="paramOuSelect" v-model="formInline.ouName" style="width:auto" :placeholder="$t('peaseSelect')" :popper-append-to-body="false" @change="changeParamOu" clearable @visible-change="visibleChange">
          <el-option :value="formInline.ouName" style="height:auto;padding:0px">
            <el-tree ref="paramOuTree" node-key="id" default-expand-all highlight-current :expand-on-click-node="false" :data="ouList" :props="defaultProps" @node-click="selectParamOu">
            </el-tree>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('Electronicfence')">
        <el-input v-model="formInline.electronicFenceName" clearable :placeholder="$t('Electronicfence')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('userNameH')">
        <el-input v-model="formInline.userName" clearable :placeholder="$t('userNameH')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('appName')">
        <el-input v-model="formInline.appName" clearable :placeholder="$t('appName')"></el-input>
      </el-form-item>
      
      <el-form-item :label="$t('Recordtime')" class="datetime">
        <el-date-picker
          v-model="formInline.searchTimeB"
          :placeholder="$t('startDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('TO')" class="datetime">
        <el-date-picker
          v-model="formInline.searchTimeE"
          :placeholder="$t('endDate')"
          type="date"
          value-format="yyyy-MM-dd"
          popper-class="date-picker-blue-hw"
          :clearable="true"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item :label="$t('serialNumberP')">
        <el-input v-model="formInline.helmetId" clearable :placeholder="$t('serialNumberP')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" class="serachBtn" @click="getList" v-preventReClick="1000">{{ $t('query') }}</el-button>
        <el-button
          type="primary"
          class="serachBtn letter_delet"
          v-has="'sys:new:setting:log:data:delete'"
          @click="handleDelet"
          v-preventReClick="1000"
          >{{ $t('batchDelete') }}</el-button
        >
        <el-button type="primary" @click="exportList" :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
      </el-form-item>
    </el-form>
    <!-- table 组件 -->
    <Table
      v-loading="loading"
      :data="tableData"
      :columns="columns"
      :operation="dateOperation"
      :tableHeight="630"
      :type="type"
      ref="tanleAssembly"
      @getList="getList"
      @operate="operationEvent"
      :currentPage="currentPage"
      :pageSize="pageSize"
      :operationWidth="100"
      @sortChange="handleSort"
    ></Table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalData"
    >
    </el-pagination>
  </div>
</template>
<script>
// 引入table组件
import Table from '@/components/NewTable'
// 引入接口
import { getGeoFences, deleteGeoFenceLog, mediaUploadAppNames } from '@/api/log'
import { getOus } from '@/api/UserList'
import { getExportGeoFences } from '@/api/log/log'
import { downloadBlobExcel } from '@/util/common'
import { beforeWeekDate, nowDate, getDaysDiff } from '@/util/date'
export default {
  name: 'GeoFenceRecord',
  props: {
    // 实时监控》历史记录》组件弹窗传用户名
    userId: {
      type: String,
    },
  },
  data() {
    return {
      ouList: [],
      // 表单查询字段
      formInline: {
        ouName: '',
        ouId: '',
        helmetId: '',
        userName: '',
        appName: '',
        electronicFenceName: '',
        searchTimeB: beforeWeekDate(),
        searchTimeE: nowDate(),
      },
      // 当前页
      currentPage: 1,
      // 当前 10条/页
      pageSize: 10,
      // 所有数据总条数
      totalData: 0,
      columns: [],
      dateOperation: [],
      tableData: [],
      // 用于批量删除 公共组件类型判断
      type: 'geoFence',
      // 查询 ’应用程序‘的数据
      appNames: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
     exportLoading: false,
     showTip: false,
     // 遮罩层
     loading: false,
    }
  },
  components: {
    Table,
  },
  methods: {
    //导出列表
    exportList() {
      if(this.totalData >= 100000) {
        this.$message({
          type: 'warning',
          message: this.$t('maxFile'),//提示用户数据量过大，无法导出
        })
        return
      }
      this.exportLoading = true
      let params = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.searchTimeB,
        logDateEnd: this.formInline.searchTimeE,
        userName: this.formInline.userName,
        appName: this.formInline.appName,
        electronicFenceName: this.formInline.electronicFenceName,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      getExportGeoFences(params).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('ElectronicFencerecord') + '.xls')
      })
    },
     // 排序
     handleSort(data) {
      this.formInline.sortColName = !data.order ? null : data.prop
      this.formInline.useAsc = data.order=== "descending" ? 0 : 1
      this.getList()
    },
     // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.formInline.ouName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 获取组织机构
    getOusTree() {
      getOus().then((res) => {
        if (res.state === 0) {
          this.ouList = res.data
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.formInline.ouName = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },
    // 批量删除
    handleDelet() {
      this.$refs.tanleAssembly.handleDeletList()
    },
    // 操作按钮
    operationEvent(row, value, index) {
      if (row.type === 'delect') {
        this._delectGeoFenceLog(row)
      }
    },
    // 删除电子围栏日志
    _delectGeoFenceLog(row) {
      this.$confirm(this.$t('deleteTip'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
        closeOnClickModal: false,
      }).then(() => {
        let params = {
          userId: row.value.userId,
          sid: row.value.sid,
          logTimestamp: row.value.logTimestamp,
        }
        deleteGeoFenceLog(params).then(res => {
          if (res.state === 0) {
            this.$message({
              type: 'success',
              message: this.$t('deleteSuccess'),
            })
            this.basicConfig()
          }
        })
      })
    },
    handleSizeChange(val) {
      // 清空批量选择的数据
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.pageSize = val
      this.basicConfig()
    },
    handleCurrentChange(val) {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = val
      this.basicConfig()
    },
    // 查询
    getList() {
      this.$refs.tanleAssembly.handleSelectionEmpty()
      this.currentPage = 1
      this.handleSearch()
    },
    handleSearch() {
      let daysDiff = getDaysDiff(this.formInline.searchTimeB, this.formInline.searchTimeE)
      if (!this.showTip && daysDiff > 30) {
        this.$confirm(this.$t('searchDataTip'), {
          confirmButtonText: this.$t('determine'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning',
          closeOnClickModal: false,
        })
          .then(() => {
            this.basicConfig()
            this.showTip = true
          })
          .catch(() => {
            this.showTip = false
            return
          })
      } else {
        this.basicConfig()
      }
    },
    // 基础配置数据
    basicConfig() {
      this.loading = true
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        ouId: this.formInline.ouId,
        ouName: this.formInline.ouName,
        helmetId: this.formInline.helmetId,
        logDateBegin: this.formInline.searchTimeB,
        logDateEnd: this.formInline.searchTimeE,
        userName: this.formInline.userName,
        appName: this.formInline.appName,
        electronicFenceName: this.formInline.electronicFenceName,
        sortColName: this.formInline.sortColName,
        useAsc: this.formInline.useAsc,
      }
      // 获取电子围栏table数据
      getGeoFences(param).then(res => {
        if (res.state === 0) {
          this.loading = false
          // 遍历循环 判断event的type传输代表的文字
          res.value.list.forEach((item, index) => {
            switch (item.event) {
              case 0:
                item.event = this.$t('Stayinfence')
                item.stayTime = ''
                break
              case 1:
                item.event = this.$t('停留在围栏外')
                item.stayTime = ''
                break
              case 2:
                item.event = this.$t('进入')
                break
              case 3:
                item.event = this.$t('离开')
                item.stayTime = ''
                break
              default:
                item.event = this.$t('未知')
                item.stayTime = ''
                break
            }
          })
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
      // table 表头配置数据
      this.columns = [
        {
          attrName: 'ouName',
          label: this.$t('mechanism'),
          sort: 'ouName',
        },
        {
          attrName: 'userName',
          label: this.$t('userNameH'),
          sort: 'userName',
        },
        {
          attrName: 'helmetId',
          label: this.$t('serialNumberP2'),
          sort: 'helmetId',
        },
        {
          attrName: 'electronicFenceName',
          label: this.$t('Electronicfence'),
          sort: 'electronicFenceName',
        },
        {
          attrName: 'event',
          label: this.$t('eventH'),
          align: 'center',
          width: '100',
          sort: 'event',
        },
        {
          attrName: 'stayTime',
          label: this.$t('stayTime'),
          align: 'right',
          sort: 'stayTime',
        },
        {
          attrName: 'appName',
          label: this.$t('appName'),
          sort: 'appName',
        },
        {
          attrName: 'logTimestamp',
          label: this.$t('Recordtime'),
          width: '180',
          align: 'center',
          sort: 'logTimestamp',
        },
        {
          attrName: 'uploadTimestamp',
          label: this.$t('uploadTimestamp'),
          width: '180',
          align: 'center',
          sort: 'uploadTimestamp',
        },
      ]
      // table 操作栏配置
      this.dateOperation = [
        {
          operateName: '',
          icon: require('@/icon/new-common/icon_delete.png'),
          type: 'delect',
          IsHad: '',
        },
      ]
    },
    // 查询获取媒体上传appNameList
    getAppNames() {
      mediaUploadAppNames().then(res => {
        if (res.state === 0) {
          this.appNames = []
          for (let i = 0; i < res.value.length; i++) {
            this.appNames.push({ value: res.value[i], label: res.value[i] })
          }
        }
      })
    },
  },
  created() {
    this.basicConfig()
    // this.getAppNames()
    this.getOusTree()
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  height 630px!important
  // min-height 500px!important;/* no */
  overflow: auto
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.letter_delet
  margin-left: 10px
</style>
